import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { AccordionCard } from '../../../components/Library/AccordionCard';
import { Card } from '../../../components/Library/Card';
import { AlgoInput } from '../../../types';
import { colors } from '../../../utils/theme';

export const AlgoInputs = (props: { email: string; input?: AlgoInput }) => {
  const { email, input } = props;

  const inputCardsProps = () => [
    {
      title: 'user-related data',
      peek: `${email} (id: ${input?.data.user.user_id})`,
      data: input?.data.user,
    },
    {
      title: 'blood data',
      peek: `${email} (id: ${input?.data.user.user_id})`,
      data: input?.data.blood,
    },
    {
      title: 'dna data',
      peek: `${email} (id: ${input?.data.user.user_id})`,
      data: input?.data.dna,
    },
    {
      title: 'hormone data',
      peek: `${email} (id: ${input?.data.user.user_id})`,
      data: input?.data.hormone['cortisol'],
    },
    {
      title: 'quiz data',
      peek: `${email} (id: ${input?.data.user.user_id})`,
      data: input?.data.lifestyle,
    },
  ];

  return (
    <Box padding={2}>
      <Card
        title={'Algo Inputs'}
        content={
          <>
            {input ? (
              <Box paddingTop={2}>
                {inputCardsProps().map((props) => (
                  <Box sx={{ mb: 2 }} key={props.title}>
                    <InputCard {...props} />
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography variant="h6" sx={{ mb: 2 }}>
                {email} Not found
              </Typography>
            )}
          </>
        }
        cardStyles={{
          background: colors.greys.GREY_300,
          color: colors.greys.BRAND_BLACK,
        }}
      />
    </Box>
  );
};

const InputCard = (props: { title: string; peek: string; data?: any }) => {
  const { title, data } = props;

  return (
    <AccordionCard
      summary={
        <Typography variant="medium" fontSize={20}>
          {title.toUpperCase()}
        </Typography>
      }
      details={
        <>
          {Array.isArray(data) ? (
            <Grid container>
              {data.map((item: any) => (
                <Grid item key={item.id} xs={6}>
                  <pre>{JSON.stringify(item, null, 2)}</pre>
                </Grid>
              ))}
            </Grid>
          ) : (
            <pre>{JSON.stringify(data, null, 2)}</pre>
          )}
        </>
      }
      panelId={title}
    />
  );
};
